module.exports = __webpack_public_path__ + "img/chivas-agepage-bg.21884a5c.png";